<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-messages icon"></i>
        <span>Suporte</span>
      </h1>
      <router-link :to="{ name: 'supportCreate' }">
        <PrimaryButton class="px-5" icon="fa-solid fa-solid fa-plus">Novo suporte</PrimaryButton>
      </router-link>
    </div>
  </div>


  <div class="align p-4 space_title">

    <div v-if="!loading || supports.data" class="card">
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Assunto</th>
            <th>Status</th>
            <th>Data</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(support, key) in supports.data" :key="key">
            <td>
              {{ support.id }}
            </td>
            <td>
              {{ support.title }}
            </td>
            <td>
              <span class="badge" :style="'background-color: ' + support.status_color">{{ support.status_name }}</span>
            </td>
            <td>
              {{ $dateFormat(support.created_at) }}
            </td>
            <td class="actions">
                <router-link :to="{ name: 'support', params: { id: support.id }}">
                  <button class="btn btn-secondary" type="button">
                    <i class="fa-regular fa-edit"></i>
                  </button>
                </router-link>
            </td>
          </tr>
          <tr class="no_result" v-if="!supports.data || (supports.data && !supports.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>


    <ListPagination class="mt-4" :links="supports.meta.links" />
  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import { onBeforeMount, ref, watch } from 'vue';
import { useSupportStore } from '@/stores/SupportStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute } from 'vue-router';

const loader = inject('$loader');
const loading = ref(false);

const route = useRoute();
const supportStore = useSupportStore();
const { supports, filter } = storeToRefs(supportStore);


onBeforeMount(() => {
  loadSupports();
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadSupports();
  }
});

async function loadSupports() {
  loader.show();
  loading.value = true;

  filter.value.page = parseInt(route.query.page);
  filter.value.limit = 10;

  await supportStore.getSupports();
  loader.hide();
  loading.value = false;
}
</script>